import { AuthenticationStatus } from '@mc-alberta/types';
/**
 * Return if the authentication status is a fatal status
 */
export function isFatalStatus(authenticationStatus) {
    switch (authenticationStatus) {
        case AuthenticationStatus.NOT_SUPPORTED:
        case AuthenticationStatus.CHALLENGE_FAILED:
        case AuthenticationStatus.CANCELLED:
        case AuthenticationStatus.EXPIRED:
            return true;
        default:
            return false;
    }
}
